import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _templateObject, _templateObject2, _templateObject3;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import * as React from "react";
import styled from "../../styled-components";
import { darken } from "polished";
import * as GithubSlugger from "github-slugger";
import throttle from "lodash.throttle";
import { useFullHeight } from "../../hooks";
import { mediaCSS } from "@redocly/reference-docs";
var slugger = new GithubSlugger(),
    HEADING_GAP = 1;

function useActiveHeading(a) {
  var _React$useState = React.useState(void 0),
      b = _React$useState[0],
      c = _React$useState[1],
      d = React.useMemo(function () {
    return a && a.querySelectorAll(".hidden-anchor");
  }, [a]),
      e = React.useCallback(throttle(function () {
    if (d) for (var _a = 0; _a < d.length; _a++) {
      var _b = d[_a].parentNode;

      if (_b && _b.offsetTop - HEADING_GAP > window.scrollY) {
        var _b2 = 0 === _a ? void 0 : d[_a - 1].getAttribute("id") || void 0;

        return void c(_b2);
      }
    }
  }), [d]);

  return React.useEffect(function () {
    if ("undefined" != typeof window && d && d.length) return window.addEventListener("scroll", e, {
      capture: !1
    }), e(), function () {
      return window.removeEventListener("scroll", e);
    };
  }, [e]), b;
}

export default function TableOfContent(a) {
  var _b$;

  var b = a.headings,
      c = a.tocMaxDepth,
      d = React.useRef(null);
  useFullHeight(d);
  var e = useActiveHeading(a.contentWrapper);
  return slugger.reset(), b && 1 === b.length && 1 === ((_b$ = b[0]) === null || _b$ === void 0 ? void 0 : _b$.depth) ? null : /*#__PURE__*/React.createElement(React.Fragment, null, b && /*#__PURE__*/React.createElement(TableOfContentMenu, null, /*#__PURE__*/React.createElement(TableOfContentItems, {
    ref: d
  }, b.map(function (a) {
    var _a$value;

    return _objectSpread(_objectSpread({}, a), {}, {
      value: (_a$value = a.value) === null || _a$value === void 0 ? void 0 : _a$value.replace(/(<([^>]+)>)/gi, "")
    });
  }).map(function (a, b) {
    if (0 === b && 1 === a.depth) return null;
    if (a.depth && a.depth > c) return null;
    var d = "#" + (a.id ? a.id : slugger.slug(a.value, !1));
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: d,
      depth: a.depth || 0,
      href: d,
      className: "#" + e == d ? "active" : "",
      dangerouslySetInnerHTML: {
        __html: a.value || ""
      },
      "data-cy": "toc-" + a.value
    });
  }))));
}
var MenuItem = styled.a(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: block;\n  color: ", ";\n  cursor: pointer;\n  font-size: 0.8em;\n  padding: 10px 20px;\n  padding-left: ", "px;\n  transition: background-color 0.3s, color 0.3s;\n  text-decoration: none;\n  word-break: break-word;\n  ", "\n  :hover,\n  &.active {\n    color: ", ";\n    background-color: ", ";\n  }\n\n  :empty {\n    padding: 0;\n  }\n"])), function (_ref) {
  var a = _ref.theme;
  return a.colors.text.primary;
}, function (_ref2) {
  var a = _ref2.depth;
  return 15 * (a - 1);
}, function (_ref3) {
  var a = _ref3.theme;
  return mediaCSS({
    fontFamily: a.typography.headings.fontFamily
  });
}, function (_ref4) {
  var a = _ref4.theme;
  return a.colors.primary.main;
}, function (_ref5) {
  var a = _ref5.theme;
  return darken(.1, a.colors.primary.contrastText);
}),
    TableOfContentMenu = styled.aside(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  font-size: 1rem;\n  background-color: transparent;\n  flex-shrink: 0;\n  display: none !important;\n\n  ", "\n\n  @media only screen and (min-width: ", ") {\n    width: ", ";\n    display: block !important;\n  }\n"])), function (_ref6) {
  var a = _ref6.theme;
  return mediaCSS({
    fontFamily: a.typography.fontFamily
  });
}, function (_ref7) {
  var a = _ref7.theme;
  return a.breakpoints.medium;
}, function (_ref8) {
  var a = _ref8.theme;
  return a.tocPanel.width;
}),
    TableOfContentItems = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  position: fixed;\n  overflow-y: auto;\n  padding: 20px 0;\n  width: ", ";\n"])), function (_ref9) {
  var a = _ref9.theme;
  return a.tocPanel.width;
});